import { useEffect, useState } from "react";

/**
 * Hook that returns the current list of SpeechSynthesis voices.
 * Voices load asynchronously in Chrome/Edge — we listen to `voiceschanged`.
 */
export const useSpeechVoices = () => {
  const [voices, setVoices] = useState(() => {
    if (typeof window === "undefined" || !window.speechSynthesis) return [];
    return window.speechSynthesis.getVoices() || [];
  });

  useEffect(() => {
    if (typeof window === "undefined" || !window.speechSynthesis) return undefined;
    const load = () => setVoices(window.speechSynthesis.getVoices() || []);
    load();
    window.speechSynthesis.addEventListener("voiceschanged", load);
    return () => window.speechSynthesis.removeEventListener("voiceschanged", load);
  }, []);

  return voices;
};
